/**
 * Created by jonas on 2020-03-18.
 */

import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {SerialIntroPage} from "./SerialIntroPage";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";

export class SerialIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0.4, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xWays : true,
        xWaysInfectious : true,
        xNudge : true,
        xSplit : true,
        xBet : true,
        xBizarre : true,
        volatility : Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
    }

    public async init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("logo", "resources/images/intro_logo.png");
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("borderBottom", "resources/images/Frame_bottom.png");
        imgLoader.add("borderTop", "resources/images/Frame_up.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add({
            family : "VCR OSD Mono",
            weight : FontWeight.NORMAL,
            style : FontStyle.NORMAL,
            url : "/resources/fonts/VCR_OSD_MONO_1.001 2.ttf"
        });

        await Promise.all([imgLoader.load(), fontLoader.load()]);
        await this.initGraphics();
        return this;
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("borderTop"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("borderBottom"));
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new SerialIntroPage([
                {
                    texture : ImgLoader.getImgTexture("feature1"),
                    scale : 1,
                    position : new PIXI.Point(0, 0)
                }
            ]),
            new SerialIntroPage([
                {
                    texture : ImgLoader.getImgTexture("feature2"),
                    scale : 1,
                    position : new PIXI.Point(0, 0)
                }
            ]),
            new SerialIntroPage([
                {
                    texture : ImgLoader.getImgTexture("feature3"),
                    scale : 1,
                    position : new PIXI.Point(0, 0)
                }
            ])
        ];
    }
}